import React from 'react';
import { Button, ButtonColor, ButtonType } from '@lux/buttons';
import * as S from '../index.styles';
export var SeeAllCard = function (_a) {
    var href = _a.href, onClick = _a.onClick, _b = _a.buttontext, buttontext = _b === void 0 ? 'See All' : _b, image = _a.image, titlePosition = _a.titlePosition;
    return (React.createElement(S.SeeAllWrapper, null,
        React.createElement(S.SeeAllBackdrop, { image: image },
            React.createElement(S.SeeAllOverlay, null)),
        React.createElement(S.SeeAll, { onClick: onClick, href: href, "$titlePosition": titlePosition },
            React.createElement(Button, { as: "span", buttonType: ButtonType.tertiary, color: ButtonColor.dark, "data-testid": "see-all-button" }, buttontext))));
};
